import React from "react";
import { useTranslation } from "react-i18next";

const Pagination = ({ current = 1, pages, handlePagination }) => {
  const { i18n } = useTranslation();
  const isRtl = i18n.language === "ar";

  return (
    <ul
      className="pagination justify-content-center"
      dir={isRtl ? "rtl" : "ltr"}
    >
      <li className="page-item">
        <button
          type="button"
          className="page-link Previous"
          aria-label="Previous"
          onClick={() => handlePagination(current - 1)}
          disabled={current <= 1}
        >
          <span
            aria-hidden="true"
            className="fas fa-chevron-left fa-fw"
          />
        </button>
      </li>

      {[...Array(pages)].map((_, i) => {
        const pageNumber = i + 1;
        let showPage = false;

        if (current <= 3) {
          showPage = pageNumber <= 5;
        } else if (current >= pages - 2) {
          showPage = pageNumber > pages - 5;
        } else {
          showPage =
            pageNumber >= current - 2 && pageNumber <= current + 2;
        }

        if (!showPage) return null;

        return (
          <li
            key={`page-${pageNumber}`}
            className={current === pageNumber ? "page-item active" : "page-item"}
          >
            <button
              type="button"
              className="page-link"
              onClick={() => handlePagination(pageNumber)}
            >
              {pageNumber}
            </button>
          </li>
        );
      })}

      <li className="page-item">
        <button
          type="button"
          className="page-link Next"
          aria-label="Next"
          onClick={() => handlePagination(current + 1)}
          disabled={current >= pages}
        >
          <span
            aria-hidden="true"
            className="fas fa-chevron-right fa-fw"
          />
        </button>
      </li>
    </ul>
  );
};

export default Pagination;
